<template>
  <div class="customl-modal-overlay" v-if="visible" @click.self="close">
    <div class="customl-modal-container">
      <!-- Header -->
      <div class="customl-modal-header">
        <div class="customl-modal-title">
          <i class="bx bx-transfer mr-2"></i>
          {{ getTranslations('expression_199') }}
        </div>
        <button class="customl-close-button" @click="close">
          <i class="bx bx-x"></i>
        </button>
      </div>

      <!-- Body -->
      <div class="customl-modal-body">
        <label class="mb-2">{{ getTranslations('expression_48') }}</label>
        <select v-model="selectedOperatorId" class="form-control custom-select">
          <option selected disabled :value="null">
            {{ getTranslations('expression_285') }}
          </option>
          <option v-for="operator in getOperatorsArray('department_id', wallets.wallet.department_id)"
            v-if="[0, 1].includes(getUserObject('id', operator.user_id).role_key)" :key="operator.id"
            v-show="operator.user_id !== users.user.id" :value="operator.id">
            {{ getUserObject('id', operator.user_id).name }}
          </option>
        </select>
      </div>

      <!-- Footer -->
      <div class="customl-modal-footer">
        <button class="btn btn-secondary shadow-sm px-4" @click.prevent="transferWallet"
          :disabled="!selectedOperatorId || isTransferring">
          <span v-if="isTransferring">
            <i class="bx bx-loader-alt bx-spin mr-1"></i>
            Transferindo...
          </span>
          <span v-else>
            {{ getTranslations('expression_538') }}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'ModalTransferWallet',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedOperatorId: null,
      isTransferring: false,
      currentLeadId: null
    };
  },
  computed: {
    ...mapState(['leads', 'wallets', 'users']),
    ...mapGetters([
      'getUserObject',
      'getOperatorObject',
      'getOperatorsArray',
      'getTranslations',
    ]),
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        // Reset selection when modal opens
        this.selectedOperatorId = null;
        this.isTransferring = false;
        
        // Capturar o lead_id atual baseado na rota ou wallet
        this.currentLeadId = this.getCurrentLeadId();
        
        console.log('Modal opened for lead:', this.currentLeadId);
      }
    }
  },
  methods: {
    getCurrentLeadId() {
      // Primeiro, tenta pegar da wallet atual
      if (this.wallets.wallet && this.wallets.wallet.lead_id) {
        return this.wallets.wallet.lead_id;
      }
      
      // Se não encontrar, tenta pegar do localStorage
      const leadIdFromStorage = window.localStorage.getItem("lead_id");
      if (leadIdFromStorage) {
        return parseInt(leadIdFromStorage);
      }
      
      // Se não encontrar, tenta pegar do lead atual na store
      if (this.leads.lead && this.leads.lead.id) {
        return this.leads.lead.id;
      }
      
      return null;
    },
    
    close() {
      this.selectedOperatorId = null;
      this.isTransferring = false;
      this.$emit('close');
    },

    async transferWallet() {
  if (!this.selectedOperatorId || this.isTransferring) {
    return;
  }

  this.isTransferring = true;

  try {
    const walletCopy = { ...this.wallets.wallet };
    walletCopy.main_operator_id = this.selectedOperatorId;

    // console.log('Transferring wallet:', walletCopy);
    // console.log('Current lead ID:', this.currentLeadId);

    // Definir os dados corretos baseado na rota
    if (this.$route.name === 'User') {
      walletCopy.data = {
        user_id: window.localStorage.getItem("user_id")
      };
    } else {
      walletCopy.data = {
        lead_id: this.currentLeadId
      };
    }

    // Atualizar a wallet
    await this.$store.dispatch('updateWallet', walletCopy);
    
    // Emitir evento de sucesso imediatamente
    this.$emit('transferred');
    this.close();

  } catch (error) {
    console.error('Error transferring wallet:', error);
    this.$swal.fire({
      icon: 'error',
      title: 'Erro',
      text: 'Erro ao transferir carteira. Tente novamente.',
      timer: 2000
    });
  } finally {
    this.isTransferring = false;
  }
}
  }
};
</script>

<style scoped>
.customl-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.customl-modal-container {
  width: 100%;
  max-width: 500px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.customl-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #eee;
}

.customl-modal-title {
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.customl-close-button {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.customl-modal-body {
  padding: 20px 24px;
}

.customl-modal-footer {
  padding: 16px 24px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #eee;
}
</style>